import '@hopin-team/ckeditor5-build-hopin/dist/translations/de';
import '@hopin-team/ckeditor5-build-hopin/dist/translations/ja';
